import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import {
  UnfreezeAccountResponse,
  FreezeNoticeResponse,
} from '../models/emergency-control.model';
import { ApiResponse } from '@shared/models/api-response.models';

/**
 * All HTTP calls in this service return the standard
 * `ApiResponse<T>` envelope.
 */
@Injectable({ providedIn: 'root' })
export class EmergencyControlService {
  private readonly apiUrl = environment.userManagementApiUrl;

  constructor(private readonly http: HttpClient) {}

  unfreezeAccount(
    reason: string
  ): Observable<ApiResponse<UnfreezeAccountResponse>> {
    return this.http.post<ApiResponse<UnfreezeAccountResponse>>(
      `${this.apiUrl}/api/account/v1/unfreeze`,
      { reason }
    );
  }

  getFreezeNotice(): Observable<ApiResponse<FreezeNoticeResponse>> {
    return this.http.get<ApiResponse<FreezeNoticeResponse>>(
      `${this.apiUrl}/api/notice/v1/freeze`
    );
  }
}
